import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

import type { Profile } from "@/api/bale.zod";

import { profileDisplayName, profileHasDisplayName } from "@/model/profile";

import { Avatar } from "./Avatar";

export function ProfileItem({
  className,
  profile,
  note,
  hideAvatar = false,
  hideName = false,
  hideId = false,
  noLink = false,
}: {
  className?: string;
  profile: Profile;
  note?: string | null;
  hideAvatar?: boolean;
  hideId?: boolean;
  hideName?: boolean;
  noLink?: boolean;
}) {
  return (
    <div className={twMerge("flex flex-row items-center gap-2", className)}>
      {!hideAvatar &&
        (noLink ? (
          <Avatar accountId={profile.id} />
        ) : (
          <Link to={`/profile/${profile.id}`}>
            <Avatar accountId={profile.id} />
          </Link>
        ))}
      {!hideName && (
        <div className="flex flex-col">
          <div className="font-interest">
            {noLink ? (
              profileDisplayName(profile)
            ) : (
              <Link className="hover:underline" to={`/profile/${profile.id}`}>
                {profileDisplayName(profile)}
              </Link>
            )}
          </div>
          <div className="font-hint text-placeholder">
            {!hideId && profileHasDisplayName(profile) && profile.id}
            {!!note && !hideId && profileHasDisplayName(profile) && "-"}
            {note}
          </div>
        </div>
      )}
    </div>
  );
}
